import ApiCall from './ApiCall';

export default ApiCall;